module.exports = __webpack_public_path__ + "img/8.0e96eb99.jpg";